
// import router from "../router/index";
// import store from "../store";
import BaseApi from "./BaseApi";

export default class ReportService extends BaseApi {

    constructor(){
        super();
    }


    async reportRequisitions(start, end)
    {
        return this.http.get(`${this.baseUrl}/reports/requisitions/${start}/${end}`)
        .catch(this.handleErrorResponse);
    }


    async exportRequisitions(start, end)
    {
        return this.http.get(`${this.baseUrl}/reports/requisitions/${start}/${end}/excel`,
            {
                responseType: "blob",
                headers:  { "Access-Control-Allow-Origin": "*" },
                exposedHeaders: ["Content-Disposition"],
            }
        )
        .catch(this.handleErrorResponse);
    }


    async reportPurchaseOrders(start, end)
    {
        return this.http.get(`${this.baseUrl}/reports/purchase-orders/${start}/${end}`,
            
        )
        .catch(this.handleErrorResponse);
    }
    async exportReportPurchaseOrders(start, end)
    {
        return this.http.get(`${this.baseUrl}/reports/purchase-orders/${start}/${end}/excel`,
            {
                responseType: "blob",
                headers:  { "Access-Control-Allow-Origin": "*" },
                exposedHeaders: ["Content-Disposition"],
            }
        )
        .catch(this.handleErrorResponse);
    }

    async reportEntryOrders(start, end)
    {
        return this.http.get(`${this.baseUrl}/reports/entry-orders/${start}/${end}`)
        .catch(this.handleErrorResponse);
    }


    async exportReportEntryOrders(start, end)
    {
        return this.http.get(`${this.baseUrl}/reports/entry-orders/${start}/${end}/excel`,
            {
                responseType: "blob",
                headers:  { "Access-Control-Allow-Origin": "*" },
                exposedHeaders: ["Content-Disposition"],
            }
        )
        .catch(this.handleErrorResponse);
    }

   
}